// extracted by mini-css-extract-plugin
export default {"user_name":"User_user_name__GjwuD","user_login":"User_user_login__yc-II","follow_info":"User_follow_info__zhYs2","subscribers_count":"User_subscribers_count__KoN6n"};